const baseUrl = 'https://prod.saralifestyle.com';

export default baseUrl;
